<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Copyright-rw exclude-print-rw page-open-auto-rw" epub:type="frontmatter copyright-page" id="Copyright1">
<div class="block-rw copyright-rw" id="copyright1">
<p class="crt-rw" id="p5"><span>This book is a work of fiction. Names, characters, places, and incidents are the product of the author’s imagination or are used fictitiously. Any resemblance to actual events, locales, or persons, living or dead, is coincidental.</span></p>
<p class="crt-rw" id="p6"><span>Copyright © 2018 by PZ Reizin Ltd.<br/>
Cover design by Elizabeth Connor. Cover photograph © Severin Matusek/Getty Images<br/>
Cover copyright © 2018 by Hachette Book Group, Inc.<br/>
Simultaneously published by Little Brown UK</span></p>
<p class="crt-rw" id="p8"><span>Hachette Book Group supports the right to free expression and the value of copyright. The purpose of copyright is to encourage writers and artists to produce the creative works that enrich our culture.</span></p>
<p class="crt-rw" id="p9"><span>The scanning, uploading, and distribution of this book without permission is a theft of the author’s intellectual property. If you would like permission to use material from the book (other than for review purposes), please contact permissions@hbgusa.com. Thank you for your support of the author’s rights.</span></p>
<p class="crt-rw" id="p14"><span>Grand Central Publishing<br/>
Hachette Book Group<br/>
1290 Avenue of the Americas, New York, NY 10104<br/><a href="http://grandcentralpublishing.com" target="_blank">grandcentralpublishing.com</a><br/><a href="http://twitter.com/grandcentralpub" target="_blank">twitter.com/grandcentralpub</a></span></p>
<p class="crt-rw" id="p15"><span>First US Edition: January 2018</span></p>
<p class="crt-rw" id="p16"><span>Grand Central Publishing is a division of Hachette Book Group, Inc. The Grand Central Publishing name and logo is a trademark of Hachette Book Group, Inc.</span></p>
<p class="crt-rw" id="p17"><span>The publisher is not responsible for websites (or their content) that are not owned by the publisher.</span></p>
<p class="crt-rw" id="p18"><span>The Hachette Speakers Bureau provides a wide range of authors for speaking events. To find out more, go to www.hachettespeakersbureau.com or call (866) 376-6591.</span></p>
<p class="crt-rw" id="p19"><span>Library of Congress Cataloging-in-Publication Data has been applied for.</span></p>
<p class="crt-rw" id="p21"><span>ISBNs: 978-1-4789-7426-0 (hardcover), 978-1-4789-2368-8 (audiobook, downloadable) 978-1-4789-7427-7 (ebook)</span></p>E3-20191114-PDJ-PC-DPU
         
         </div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s002-Copyright-01.vue?023a6c95